import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { StationCardComponent } from '~components/station-card/station-card.component';
import type { Station } from '~models/station.model';

@Component({
  selector: 'app-list-view',
  imports: [StationCardComponent],
  templateUrl: './list-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewComponent {
  readonly stations = input.required<Station[]>();
}
